// @ts-nocheck
import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import getLocalizedDateTime from "@insite/client-framework/Common/Utilities/getLocalizedDateTime";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCurrentBillToState } from "@insite/client-framework/Store/Data/BillTos/BillTosSelectors";
import { getCurrentShipToState } from "@insite/client-framework/Store/Data/ShipTos/ShipTosSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import InlineAddress from "@store/Library/Components/InlineAddress";
import { orderV2Props } from "@store/Themes/common/props/orderV2";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

interface OwnProps extends WidgetProps {}

const mapStateToProps = (state: ApplicationState) => ({
    curentBillToState: getCurrentBillToState(state),
    currentShipToState: getCurrentShipToState(state),
});

type Props = OwnProps & ReturnType<typeof mapStateToProps>;

export interface OrderUploadInformationStyles {
    wrapper?: InjectableCss;
    titleText?: TypographyPresentationProps;
    infoWrapper?: InjectableCss;
    infoLabel?: TypographyPresentationProps;
    infoValue?: TypographyPresentationProps;
}

export const orderUploadInformationStyles: OrderUploadInformationStyles = {
    wrapper: {
        css: css`
            display: flex;
            flex-direction: column;
            gap: ${pxToRem(24)};
        `,
    },
    titleText: {
        variant: "h4",
        forwardAs: "h3",
    },
    infoWrapper: orderV2Props.infoWrapper,
    infoLabel: orderV2Props.infoLabel,
    infoValue: orderV2Props.infoValue,
};

const styles = orderUploadInformationStyles;

const OrderUploadInformation = ({ curentBillToState, currentShipToState }: Props) => {
    const language = useAppSelector(state => state.context.session.language);

    if (!curentBillToState.value || !currentShipToState.value) {
        return null;
    }

    return (
        <StyledWrapper {...styles.wrapper}>
            <Typography {...styles.titleText}>{translate("Order Information")}</Typography>
            <StyledWrapper {...styles.infoWrapper}>
                <Typography {...styles.infoLabel}>{translate("Order Date")}</Typography>
                <Typography {...styles.infoValue}>
                    {getLocalizedDateTime({ dateTime: new Date(), language })}
                </Typography>
            </StyledWrapper>
            <StyledWrapper {...styles.infoWrapper}>
                <Typography {...styles.infoLabel}>{translate("Sold-To Address")}</Typography>
                <InlineAddress extendedStyles={{ addressText: styles.infoValue }} address={curentBillToState.value} />
            </StyledWrapper>
            <StyledWrapper {...styles.infoWrapper}>
                <Typography {...styles.infoLabel}>{translate("Shipping Address")}</Typography>
                <InlineAddress extendedStyles={{ addressText: styles.infoValue }} address={currentShipToState.value} />
            </StyledWrapper>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(OrderUploadInformation),
    definition: {
        displayName: "Greif Information",
        group: "Order Upload",
        allowedContexts: ["OrderUploadPage"],
    },
};

export default widgetModule;
